/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

// import { isNil } from "lodash";
import isNil from 'lodash/isNil';
import { Children, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FormContainer, SelectElement } from "react-hook-form-mui";
import CustomTextField from "../../../util/component/CustomTextField";
import CustomFormContainer from '../../layout/CustomFormContainer';
import { getNameValueJsonArray } from "../../../util/uiHelper";
import FormSection from "../../01-atoms/FormSection";
import FormLayout from "../../layout/form";
import styles from '../../../../src/styles/FormLayout.module.css';
import SuccessErrorModal, { MessageType } from "../../modals/SuccessErrorModal";
import { BaseAlertDataInterface } from "../common/basInterface";
//Store Imports
import {setRoleResourceData,setStage, setIsAlertOpen, setMessage, setMessageType, setisReqroleresourceVisited} from '../../../redux/userRolesSlice';
import {userRoleSelector } from '../../../redux/userRolesSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useNavigate } from "react-router-dom";


interface RequestRoleResourceInterface{
     setRoleResourceSelectedData: Function
     alertOpen?: boolean
}

export default function RequestRoleResource({ setRoleResourceSelectedData,alertOpen }: RequestRoleResourceInterface) {
    const formContext = useForm<{}>({
        defaultValues: {
        }
    });

    const [resourceName, setResourceName] = useState([]);
    const [role, setRole] = useState<string[]>([]);
    const [resourceList,setResourceList] = useState([{service:0}])
    const [rolesAssigned,setRolesAssigned] = useState<string[]>([])
    // Store values
    const [typestoIndex,setTypestoIndex]=useState({0:([] as string[]),1:([] as string[]),2:([] as string[])})
    const [valuesAtIndex,setvaluesAtIndex]=useState({0:{},1:{},2:{}})
    const [isDisabled,setIsDisabled] = useState<boolean>(false)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { roleResourceData, stage ,isAlertOpen , message, messageType,isReqroleresourceVisited} = useAppSelector(userRoleSelector);
    


    const handleSuccess = async (data: any) => {
        setIsDisabled(true)
        data.iterations = resourceList.length
        setRoleResourceSelectedData(data);
    }

    const handleBack = () => {
        dispatch(setStage('OrgEngine'))
    }

    const handleResDecNav = () => {
        navigate('/roleRequest?tab=myResources')
    }

    const handleOpen = () => {
        dispatch(setIsAlertOpen(true));
    };
    const handleClose = () => {
        dispatch(setIsAlertOpen(false));
    };

    
    useEffect(() => {
        if(isReqroleresourceVisited){
            dispatch(setStage('OrgEngine'))
            // Navigate
        }
        return () => {
            resetAllCodeType();
            setTypestoIndex({0:([] as string[]),1:([] as string[]),2:([] as string[])})
            if(new URLSearchParams(window.location.search).get('tab') !== 'resourceDescriptions'){
                // dispatch(setStage('OrgEngine'))
                dispatch(setIsAlertOpen(false))
                dispatch(setMessage(''))
                dispatch(setMessageType(MessageType.info))
                dispatch(setRoleResourceData({}))
                dispatch(setisReqroleresourceVisited(true))
            }
        };
    }, [])


    useEffect(() => {
        if (roleResourceData?.resourceName?.size) {
            setResourceName(roleResourceData.resourceName)
        }
    }, [roleResourceData])  


    const resetAllCodeType = () =>{
        setvaluesAtIndex({0:{},1:{},2:{}})
    }

    const handleResourceAdd = (index:number) => {
        setResourceList([...resourceList,{service:index+1}])
    }


    const handleResourceRemove =(index:number) => {

        //reduces the number of sections by 1 each time
        const list =[...resourceList]
        list.splice(index,1)
        setResourceList(list)

        //removes the index entries
        const rolesList =[...role]
        rolesList.splice(index,1)
        setRole(rolesList)

        const AssignedrolesList =[...rolesAssigned]
        AssignedrolesList.splice(index,1)
        setRolesAssigned(AssignedrolesList)

        //sets the next elements value to current element
        formContext.resetField(`role ${index}` as never)
        formContext.resetField(`resourceName ${index}` as never)
        
        let parsedValue = JSON.parse(JSON.stringify(valuesAtIndex))
        let codeTypeAtIndex = parsedValue[index].CodeType;
        formContext.unregister(`${codeTypeAtIndex} ${index}` as never)
        let data = JSON.parse(JSON.stringify(formContext.getValues()))
        
        removeIndexValue(index)
        removeTypeAtIndex(index)

        if (index !== resourceList.length-1){
            setTypestoIndex({0:typestoIndex[0],1:typestoIndex[2],2:[]})
        }
        
        for (let i=index;i<resourceList.length;i++){


            //get the code type of the index that is being removed.
            let jsonValues = JSON.parse(JSON.stringify(valuesAtIndex))
            let codeTypeAtIndex = jsonValues[i].codeType 
            let codeTypeAtIndexnext : string = ""
            if(i !== resourceList.length-1){
                codeTypeAtIndexnext = jsonValues[i+1].codeType
            }

            //unregistering if the element removed is last element.
            if(i === resourceList.length - 1){
                formContext.unregister(`resourceName ${i}` as never)
                formContext.unregister(`role ${i}` as never)
                formContext.unregister(`${codeTypeAtIndex} ${i}` as never);
            } else{
                formContext.setValue(`resourceName ${i}` as never, (data[`resourceName ${i+1}`] as never))
                formContext.setValue(`role ${i}` as never, (data[`role ${i+1}`] as never))

                if (formContext.getValues(`${codeTypeAtIndexnext} ${i+1}` as never)=== undefined){
                    formContext.unregister(`${codeTypeAtIndex} ${i}` as never);
                    formContext.setValue(`${codeTypeAtIndexnext} ${i}` as never,undefined as never)
                } else{
                    formContext.unregister(`${codeTypeAtIndex} ${i}` as never);
                    formContext.setValue(`${codeTypeAtIndexnext} ${i}` as never, (data[`${codeTypeAtIndexnext} ${i+1}`] as never))
                }
            }
        }

        if (index === 0){
            setValuestoShow({0:valuesAtIndex[0],1:valuesAtIndex[1],2:valuesAtIndex[2]},index)
        } else if (index === 1){
            setValuestoShow({0:valuesAtIndex[0],1:valuesAtIndex[2],2:valuesAtIndex[2]},index)
        } else if (index === 2 ){
            setValuestoShow({0:valuesAtIndex[0],1:valuesAtIndex[1],2:{}},index)
        }
    }


    const roleSetting = (roles:any,index:number) => {
        // this logic will give only unique roles for the three roles that we want to select.
        let rolesToShow: string[] = []
        const rolesAssignList = [...rolesAssigned]
        if (rolesAssignList[index] !== undefined){
            rolesAssignList.splice(index,1)
            formContext.setValue(`role ${index}` as never, undefined as never)
        }

        for(let i = 0; i<resourceList.length; i++){
            let data = JSON.parse(JSON.stringify(formContext.getValues()))
            //create an array of all the roles that are already assigned.
            rolesAssignList[i]=data[`role ${i}`]
        }

        // let jsonValues = JSON.parse(JSON.stringify(valuesAtIndex))
        roles.forEach((element:any,i:number) => {
            let JsonCodeObject = JSON.parse(JSON.stringify(valuesAtIndex))
            let roleCodeMapArray = roleResourceData?.data?.rolesInfo
            if(!!roleResourceData && !!roleCodeMapArray){
                for ( let value in roleCodeMapArray)
                    if (roleCodeMapArray[value]._id === element.value){
                        //count of values > 0 chudali and also we have to check if  code type is not null
                        if (roleCodeMapArray[value].code.length > 0 && !!roleCodeMapArray[value].codeType){
                            rolesToShow.push(element)
                        } else if ( roleCodeMapArray[value].code.length === 0 && roleCodeMapArray[value].codeType === '' &&!(rolesAssignList.includes(element.value))){
                            rolesToShow.push(element)
                        }
                    }
            }
        });

        if(role[index] === undefined){
            setRole([...role,JSON.stringify(rolesToShow)])
        } else {
            const rolesList =[...role]
            rolesList[index] = JSON.stringify(rolesToShow)
            setRole(rolesList);
        }
        setRolesAssigned(rolesAssignList)
    }

    //get the code values form the corresponng role array element
    const getCodevalues = (role:any,index:number) => {
        let codeTypeAndValues
        let roleCodeMapArray = roleResourceData?.data?.rolesInfo
        if(!!roleResourceData && !!roleCodeMapArray){
            for ( let value in roleCodeMapArray)
                if (roleCodeMapArray[value]._id === role){
                    codeTypeAndValues = {"codeType" : roleCodeMapArray[value].codeType , "codeValues" : roleCodeMapArray[value].code } 
                }
        }
        return codeTypeAndValues;
    }

    // removes the code type at the index to an object
    const removeIndexValue = ( index: number ) => {
        if(index === 0) {
            setTypestoIndex({0:[],1:typestoIndex[1],2:typestoIndex[2]})
        } else if (index === 1) {
            setTypestoIndex({0:typestoIndex[0],1:[],2:typestoIndex[2]})
        } else if (index === 2) {
            setTypestoIndex({0:typestoIndex[0],1:typestoIndex[1],2:[]})
        }
    }

    //Deriving the values that we can show for selection:
    const valuesToShow = ( index: number) => {

        let valueatIndex:any ={}
        let jsonValues:any

        if(index === 0) {
           valueatIndex = valuesAtIndex[0]
        } else if (index === 1) {
            valueatIndex = valuesAtIndex[1]
        } else if (index === 2) {
            valueatIndex = valuesAtIndex[2]
        }
        // console.log(valueatIndex ,  "        ************************================> " , Object.keys(valuesAtIndex).length)

        jsonValues = JSON.parse(JSON.stringify(valuesAtIndex))
        // console.log(":::::::: ============== > " ,jsonValues)

        let nomatch = []
        let match = []

        for (let i = 0 ; i < Object.keys(jsonValues).length ; i++){
            if(jsonValues[i].roleID !== undefined){
                if (valueatIndex.roleID !== jsonValues[i].roleID){
                    nomatch.push(i)
                } else {
                    match.push(i)
                }
            }            
        }

        //now we have match and nomatch array 
        if (match.length == 1){
            jsonValues[index].codeValuesToShow = jsonValues[index].codeValues
            if (index === 0){
                setvaluesAtIndex({0:jsonValues[0],1:valuesAtIndex[1],2:valuesAtIndex[2]})
            } else if (index === 1){
                setvaluesAtIndex({0:valuesAtIndex[0],1:jsonValues[1],2:valuesAtIndex[2]})
            } else if (index === 2 ){
                setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[1],2:jsonValues[2]})
            }
        } else {
            let data = JSON.parse(JSON.stringify(formContext.getValues()));
            let usedValues:number[] = []
            for( let i = 0; i < match.length; i++){
                //if(match[i]!==index){
                    let tempCodeType = jsonValues[index].codeType
                    usedValues.push(data[`${tempCodeType} ${match[i]}`])
                //}
            }
            let codevalues = jsonValues[index].codeValues
            let filteredArr = []
            if(usedValues.length !== 0){
                filteredArr = codevalues.filter((el:number) => usedValues.indexOf(el) === -1);
            }
            jsonValues[index].codeValuesToShow = filteredArr
            for( let i = 0; i < match.length; i++){
                    let filteredCodes= []
                    let tempCodeType = jsonValues[match[i]].codeType
                    filteredCodes=[...filteredArr]
                    // if(match[i] !== index){
                    filteredCodes.push(data[`${tempCodeType} ${match[i]}`])
                    // }
                    jsonValues[match[i]].codeValuesToShow = filteredCodes                
            }
            setvaluesAtIndex({0:jsonValues[0],1:jsonValues[1],2:jsonValues[2]})
        }

        return jsonValues[index].codeValuesToShow
    }

    const setValuestoShow = (jsonvalueCodesArray:any , index:number) => {
        let valueatIndex:any ={}
        let jsonValues:any

        if(index === 0) {
           valueatIndex = jsonvalueCodesArray[0]
        } else if (index === 1) {
            valueatIndex = jsonvalueCodesArray[1]
        } else if (index === 2) {
            valueatIndex = jsonvalueCodesArray[2]
        }

        jsonValues = JSON.parse(JSON.stringify(jsonvalueCodesArray))

        let nomatch = []
        let match = []

        for (let i = 0 ; i < Object.keys(jsonValues).length ; i++){
            if(jsonValues[i].roleID !== undefined){
                if (valueatIndex.roleID !== jsonValues[i].roleID){
                    nomatch.push(i)
                } else {
                    match.push(i)
                }
            }            
        }
        if (match.length == 1){
            jsonValues[index].codeValuesToShow = jsonValues[index].codeValues
            if (index === 0){
                setvaluesAtIndex({0:jsonValues[0],1:valuesAtIndex[1],2:valuesAtIndex[2]})
            } else if (index === 1){
                setvaluesAtIndex({0:valuesAtIndex[0],1:jsonValues[1],2:valuesAtIndex[2]})
            } else if (index === 2 ){
                setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[1],2:jsonValues[2]})
            }
        } else {
            let data = JSON.parse(JSON.stringify(formContext.getValues()));
            let usedValues:number[] = []
            let usedValuesNoMatch:number[] = []
            for( let i = 0; i < match.length; i++){
                    let tempCodeType = jsonValues[match[i]].codeType
                    usedValues.push(data[`${tempCodeType} ${match[i]}`])
            }
            for( let i = 0; i < nomatch.length; i++){
                    let tempCodeType = jsonValues[nomatch[i]].codeType
                    usedValuesNoMatch.push(data[`${tempCodeType} ${nomatch[i]}`])
            }
            //console.log("used Values ****************++++++++++++++ >",usedValues)
            let codevalues = jsonValues[index].codeValues
            let filteredArr = []
            let filteredArrNoMatch = []
            if(usedValues.length !== 0){
                filteredArr = codevalues.filter((el:number) => usedValues.indexOf(el) === -1);
            }
            jsonValues[index].codeValuesToShow = filteredArr
            for( let i = 0; i < match.length; i++){
                    let filteredCodes= []
                    let tempCodeType = jsonValues[match[i]].codeType
                    filteredCodes=[...filteredArr]
                    // if(match[i] !== index){
                    filteredCodes.push(data[`${tempCodeType} ${match[i]}`])
                    // }
                    jsonValues[match[i]].codeValuesToShow = filteredCodes
                
            }
            for( let i = 0; i < nomatch.length; i++){
                let filteredCodes= []
                let filteredArrNoMatch = []
                let codevalues = jsonValues[nomatch[i]].codeValues
                let tempCodeType = jsonValues[nomatch[i]].codeType
                if(usedValuesNoMatch.length !== 0){
                    filteredArrNoMatch = codevalues.filter((el:number) => usedValuesNoMatch.indexOf(el) === -1);
                }
                filteredCodes=[...filteredArrNoMatch]
                filteredCodes.push(data[`${tempCodeType} ${nomatch[i]}`])
                jsonValues[nomatch[i]].codeValuesToShow = filteredCodes
        }
            setvaluesAtIndex({0:jsonValues[0],1:jsonValues[1],2:jsonValues[2]})
        }
    }



    //Depending on the value at the index position we render the corresponding code type
    const getCodeType = (value : number) => {
        let valueatIndex:any = {}
        let dropdownvalues:string[] = []
        let uiElement: JSX.Element = <></>;
        let children: JSX.Element[] = [];
        if(value === 0) {
           valueatIndex = valuesAtIndex[0]
        } else if (value === 1) {
            valueatIndex = valuesAtIndex[1]
        } else if (value === 2) {
            valueatIndex = valuesAtIndex[2]
        }
        

        dropdownvalues= valueatIndex.codeValuesToShow
        let label:string = ""

        if(valueatIndex.codeType === "payerCode"){
            label = "Payers Code"
        } else if(valueatIndex.codeType === "etoolingCode" ){
            label = "ETooling Code"
        } else if(valueatIndex.codeType === "soldToCodeType" ){
            label = "Sold To Code Type"
        } else if(valueatIndex.codeType === "soldToCode" ){
            label = "Sold To Code"
        } else if(valueatIndex.codeType === "eLicensingCode" ){
            label = "Licensing Code"
        } else if(valueatIndex.codeType === "ataCode" ){
            label = "ATA Code"
        } else if(valueatIndex.codeType === "ehmCode" ){
            label = "EHM Code"
        }

        {!!(valueatIndex.codeType)  ? 
        children.push(<SelectElement style={{ marginTop: '5px', marginBottom: '16px' }} className="lowHeight"
                                key={`${valueatIndex.codeType} ${value}`}
                                id={`${valueatIndex.codeType} ${value}`}
                                name={`${valueatIndex.codeType} ${value}`}
                                label={label}
                                options={getNameValueJsonArray(dropdownvalues)}
                                required={true}
                                valueKey={'value'}
                                onChange = {()=>{
                                    valuesToShow(value)
                                }}
                                labelKey="name" fullWidth margin="normal" />) : children.push(<></>)}
        uiElement = <div>{children}</div>;
        return uiElement;
    }

    //adding a role, values, codetype to an object: 
    const CodeTypeAtIndex = (value :any,index: number,codeValues: string[], codeType: string) => { 
        // console.log("value ====== ", value, "  " , index , " ========index")
        if (index === 0){
            valuesAtIndex[0]= ({"codeType":codeType,"codeValues":codeValues,"roleID":value,"codeValuesToShow":[]})
            setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[1],2:valuesAtIndex[2]})
        } else if (index === 1){
            valuesAtIndex[1]=({"codeType":codeType,"codeValues":codeValues,"roleID":value,"codeValuesToShow":[]})
            setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[1],2:valuesAtIndex[2]})
        } else if (index === 2 ){
            valuesAtIndex[2]=({"codeType":codeType,"codeValues":codeValues,"roleID":value,"codeValuesToShow":[]})
            setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[1],2:valuesAtIndex[2]})
        }
    }

    //removing an object at an index
    const removeTypeAtIndex = (index: number) => {
        if (index === 0){
            setvaluesAtIndex({0:{},1:valuesAtIndex[1],2:valuesAtIndex[2]})
        } else if (index === 1){
            setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[2],2:{}})
        } else if (index === 2 ){
            setvaluesAtIndex({0:valuesAtIndex[0],1:valuesAtIndex[1],2:{}})
        }
    }
    
    //This function is to remove the previous code type if the resource name is changed.
    const removeCodeValueFormContext = (data:any,index:number) => {
        let jsonValues = JSON.parse(JSON.stringify(valuesAtIndex))
        if(!!jsonValues[index].codeType) {
            formContext.unregister(`${jsonValues[index].codeType} ${index}` as never)
            formContext.unregister(`role ${index}` as never)
            let formcont = JSON.parse(JSON.stringify(formContext.getValues()))
        }
        jsonValues[index].codeType = undefined;
        jsonValues[index].codeValues = [];
        jsonValues[index].codeValuesToShow = [];
        jsonValues[index].roleID = undefined;
        if (index === 0){
            setValuestoShow({0:jsonValues[index],1:valuesAtIndex[1],2:valuesAtIndex[2]},index)
        } else if (index === 1){
            setValuestoShow({0:valuesAtIndex[0],1:jsonValues[index],2:valuesAtIndex[2]},index)
        } else if (index === 2 ){
            setValuestoShow({0:valuesAtIndex[0],1:valuesAtIndex[1],2:jsonValues[index]},index)
        }
        // setvaluesAtIndex({0:jsonValues[0],1:jsonValues[1],2:jsonValues[2]})
    }


    const getContent = () =>{
        let uiElement: JSX.Element = <></>;
        let children: JSX.Element[] = [];
        if(resourceList.length !== 0){
            resourceList.map((ele:any,index:any)=>{
                children.push(
                    <div key={index}>
                        <FormSection key={index}>
                            {index ===0 ?<> <p className={styles.subheaderText}>Use the form below to submit an access request to new resources. To learn more about what's available, visit the <a className={styles.subHeaderRoles} onClick={()=>{navigate('/roleRequest?tab=resourceDescriptions')}} >Resource Description</a> tab.</p>
                            <p> </p>
                            <p className={styles.subheaderText}>Some resources are only available for request or are inherited based on engine model association. View current engine model associations or request new ones in 
                            <a className={styles.subHeaderRoles} onClick={()=>{navigate('/roleRequest?tab=myEngineModels')}} > My Engines </a>
                            tab.</p>  </>:<></>}
                                <SelectElement style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
                                    key={`resourceName`}
                                    id={`resourceName`}
                                    name={`resourceName ${index}`}
                                    label={'Resource'}
                                    onChange={(value) => {
                                        formContext.resetField('role' as never)
                                        
                                        removeCodeValueFormContext(JSON.parse(JSON.stringify(formContext.getValues())) ,index)
                                        roleSetting(roleResourceData.roleDataMap.get(value),index)
                                        
                                    }}
                                    options={getNameValueJsonArray(resourceName)}
                                    required={true}
                                    valueKey={'value'}
                                    labelKey="name" fullWidth margin="normal" />
                                <SelectElement style={{ marginTop: '5px', marginBottom: '16px' }} className="lowHeight"
                                    key={`role ${index}`}
                                    id={`role ${index}`}
                                    name={`role ${index}`}
                                    label={'Role'}
                                    onChange={(value) => {
                                        const codeNameandValue: any = getCodevalues(value,index)
                                        let supportedCodeValue: string[]= codeNameandValue?.codeValues
                                        const supportedCodetypes: string = codeNameandValue?.codeType
                                        CodeTypeAtIndex(value , index,supportedCodeValue,supportedCodetypes)
                                        valuesToShow(index)
                                    }}
                                    options={getNameValueJsonArray(role[index])}
                                    required={true}
                                    valueKey={'value'}
                                    labelKey="name" fullWidth margin="normal" /> 
                                    {getCodeType(index)}
                                <div style={{display:"flex",flexDirection:"column"}}>
                                    {index !== 0 ? <div className={styles.removelink}>
                                        <a className={styles.removeElement} onClick={()=>handleResourceRemove(index)}>Remove</a>
                                </div> :
                                <div style={{marginTop:"12px"}}></div>}

                                <div style={{borderBottom:"1px solid #F0F0F0",marginBottom:"21px"}}></div>

                            {resourceList.length -1 ===index && (resourceList.length < 3) // && resourceList.length < roleResourceData?.data?.rolesInfo?.length) 
                                ?
                                    <button className={styles.addResourcesDiv} onClick={()=>{handleResourceAdd(index)}}>
                                        <div className={styles.textInlineStyle}>
                                            <div className={styles.pieceOne}><b>+</b></div>
                                            {/* <rotor-icon name="arrow"></rotor-icon> */}
                                            <div className={styles.pieceTwo}>Add Resource</div>
                                        </div>
                                    </button>
                                :
                                    <>{resourceList.length -1 ===index ?
                                        <button disabled={true} className={styles.addResourcesDivDisabled}>
                                            <div className={styles.textInlineStyle}>
                                                <div className={styles.pieceOne}><b>+</b></div>
                                                {/* <rotor-icon name="arrow"></rotor-icon> */}
                                                <div className={styles.pieceTwoDisabled}>Add Resource</div>
                                            </div>
                                        </button>
                                        :<></>}
                                    </>
                                }
                            </div>        
                        </FormSection>
                    </div>)
                })
            } else {
            children.push(<></>)
        }
        uiElement = <div>{children}</div>;
        dispatch(setIsAlertOpen(false))
        return uiElement;
    }
    
    
    return (
        <>
            <CustomFormContainer
                defaultValues={{}}
                formContext={formContext}
                onSuccess={handleSuccess}
            >
                <SuccessErrorModal
                    open={alertOpen as boolean}
                    // open={true}
                    type={messageType}
                    handleClose={handleClose}
                    message={message}
                    />
                <FormLayout
                    header="New Resource Request"
                    backButton={<button className={styles.backButton} style={{ marginRight: '5px' }} onClick={handleBack} >
                                    <div className={styles.backButtonText}>
                                        <div><b>{"<-"}</b></div><div>Back</div>
                                    </div>
                                </button>}

                    submitButtom = {<><div className={styles.requiredFieldsStyle}>* Required field</div> 
                    <button className={styles.submitButton} style={{ marginRight: '5px' }} type="submit" disabled={isDisabled} >
                                        <div className={styles.submitButtonText}>
                                            <div>{"Submit"}</div>
                                        </div>
                                    </button></>}
                    >
                    
                        
                        {/* <FormSection> */}
                        {getContent()}
                        <FormSection>                           
                                <div style={{ marginTop: '0px', marginBottom: '16px' }}>
                                <p className={styles.additionalText}>Additional Details</p>
                                <CustomTextField
                                    key={'comments'}
                                    id={'comments'}
                                    name={'comments'}
                                    disabled={false}
                                    // label={'Comments'}
                                    label={'Reason for Request'}
                                    
                                    multiline
                                    minRows={2}
                                    maxRows={4}
                                    maxLength={240}
                                    inputProps={{ maxLength:240 }}
                                    helperText={`${formContext.getValues('comments' as never)}/${240}`}
                                    margin="normal"
                                    required={true}
                                    fullWidth
                                />
                                {/* <div className={styles.requiredFieldsStyle}>* Required field</div> */}
                            </div>
                        </FormSection>
                    
                </FormLayout>
            </CustomFormContainer>
        </>
    )

}